// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608311504/js/" + chunkId + "." + {"44":"df2f0c59","225":"9f67860f","481":"d31488b1","486":"e908fe8c","770":"35816216"}[chunkId] + ".0.8377865767055523.chunk.js";
};